import React, { PureComponent, Fragment } from 'react'
import { Scrollbars } from "react-custom-scrollbars"
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import { isLoggedIn } from 'helpers'
import SideMenu from './SideMenu'
import { Loader } from 'modules/shared'
import PrivateRoute from './PrivateRoute'
import SessaoExpirada from './SessaoExpirada'
import NaoAutorizado from './NaoAutorizado'
import ServicoIndisponivel from './ServicoIndisponivel'
import Home from './Home'
import NotFound from './NotFound'
import 
	{ 
		ConferenciaSATPage, 
		ConferenciaNfcePage, 
		GerenciarEmpresasPage, 
		NFeConsultaPage,
		CTeConsultaPage,
		MovimentacaoPage,
		ReceitasFinanceirasPage 
	} 
from 'modules/fiscal'
import { PendenciasPage } from 'modules/docsystem'

class App extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			verifyingAuth: true,
			authenticated: null
		}
	}

	componentDidMount() {
		isLoggedIn().then(resp => this.setState({ verifyingAuth: false, authenticated: resp }) )
	}

	render() {
		if (this.state.verifyingAuth)
			return <Loader />
		else if (this.state.verifyingAuth === false) {
			if (this.state.authenticated === false && this.props.location.pathname !== '/sessao-expirada') {
				return <Redirect to="/sessao-expirada" />
			} else if (this.state.authenticated === true && this.props.location.pathname === '/sessao-expirada') {
				return <Redirect to="/" />
			}
		}
		
		return (
			<Fragment>
				<SideMenu />
				<Scrollbars id="main">
					<Switch>
						<Route path="/" exact component={Home}></Route>
						<PrivateRoute path="/conferencia-sat" exact toRender={ConferenciaSATPage} />
						<PrivateRoute path="/conferencia-nfce" exact toRender={ConferenciaNfcePage} />
						<PrivateRoute path="/movimentacao-todas-unidades" exact toRender={MovimentacaoPage} />
						<PrivateRoute path="/receitas-financeiras" exact toRender={ReceitasFinanceirasPage} />
						<PrivateRoute path="/empresas" exact toRender={GerenciarEmpresasPage} />
						<PrivateRoute path="/docsystem/pendencias" exact toRender={PendenciasPage} />
						<PrivateRoute path="/nfes/consultar" exact toRender={NFeConsultaPage} />
						<PrivateRoute path="/ctes/consultar" exact toRender={CTeConsultaPage} />
						<Route path="/sessao-expirada" exact component={SessaoExpirada}></Route>
						<Route path="/nao-autorizado" exact component={NaoAutorizado}></Route>
						<Route path="/servico-indisponivel" exact component={ServicoIndisponivel}></Route>
						<Route path="*" component={NotFound}></Route>
					</Switch>
				</Scrollbars>
				<div id="notification-area"></div>
			</Fragment>
		)
	}
}

export default withRouter(App)
